/* eslint-disable import/prefer-default-export */
export const SET_PDC_MESSAGE = 'SET_PDC_MESSAGE'
